<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <app-field-toggle-button
            :class="options"
            :sync="true"
            v-model="content"
            v-bind="$attrs"
            slot="input"
            @input="update()"
            ref="handle"
        />
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import ToggleButton from 'vue-js-toggle-button/src/Button'

    export default {
        name: 'app-field-text',

        components: {
            'app-field': Field,
            'app-label': Label,
            'app-field-toggle-button': ToggleButton
        },

        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            content: false
        }),

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        methods: {
            update() {
                this.$emit('input', this.content);
            }
        },

        mounted() {
            if (this.value) {
                this.content = this.value ? true : false;

                this.update();
            }
        },

        watch: {
            value(val) {
                this.content = val ? true : false;

                this.update();
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/Toggle.vue